module.exports = __webpack_public_path__ + "img/login-with-clever@2x.f17d2692.png";